import * as Services from "../services/Services"
import * as Url from "../services/Url"

export const addLocation = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_LOCATION, payload, token)
  return res;
};

export const getLocationByEmployee= async(employee) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GET_LOCATION_BY_EMPLOYEE}${employee}`, token)
  return res;
};

export const getLocationByTask= async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GET_LOCATION_BY_TASK}${id}`, token)
  return res;
};
